import { Col, Row } from 'antd';
import FeatureGuideSidebar from 'components/new-ui/composed/feature-guide-panel/FeatureGuideSidebar';
import { templateGuide } from 'components/new-ui/composed/feature-guide-panel/guides/templateGuide';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { MessageTypes } from 'store/declarations/enums/common/declaration-types';
import TemplateSelect from './TemplateSelect';

type Props = {
    country: DeclarationCountry;
    internalType: DeclarationInternalType;
    messageType: MessageTypes;
    onTemplateChange: (templateId: string | undefined) => void;
};

const guides = [templateGuide];

const GenerationView = ({ country, internalType, messageType, onTemplateChange }: Props) => {
    return (
        <Row gutter={[15, 24]}>
            <Col flex="auto">
                <TemplateSelect
                    country={country}
                    internalType={internalType}
                    messageType={messageType}
                    onSelect={(id) => onTemplateChange(id)}
                    onClear={() => onTemplateChange(undefined)}
                />
            </Col>
            <Col flex="none">
                <FeatureGuideSidebar guides={guides} />
            </Col>
        </Row>
    );
};

export default GenerationView;
